
import './audit-campaign-search-screen.scss'

import Component from 'vue-class-component';

import { SortFilter } from '@skinsoft/types';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchHeader } from '@skinsoft/search';
import { Routes } from '../../../../router';
import { AuditCampaignFeaturedList } from '../audit-campaign-featured-list';

declare const config
const AUDIT_SORTING_ENTITY_FIELDS: SortFilter[] = config.auditSortingEntityFields
const OFFLINE_AUDIT_SORTING_ENTITY_FIELDS: SortFilter[] = config.offlineAuditSortingEntityFields

@Component({
    components: {
        sAuditCampaignFeaturedList: AuditCampaignFeaturedList,
        sSearchHeader: SearchHeader,
    },
    props: ['titleI18NKey', 'searchParams'],
    template: require('./audit-campaign-search-screen.html')
})
export class AuditCampaignSearchScreen extends ReactiveVue {

    public titleI18NKey: string;

    private nbReports: string = "";
    private sortingEntityFields: any[] = [];
    private targetRouteName = Routes.CAMPAIGN;

    public mounted() {
        this.$on('nb-fetched-reports-topic', (message) => {
            this.nbReports = this.$t('listReportScreen.nbResults', { nbResults: message.nbReports }) as string;
        })

        this.updateSortingFields()
        window.addEventListener('online', this.updateSortingFields)
        window.addEventListener('offline', this.updateSortingFields)
    }

    private updateSortingFields() {
        if(window.navigator.onLine) {
            this.sortingEntityFields = AUDIT_SORTING_ENTITY_FIELDS;
        } else {
            this.sortingEntityFields = OFFLINE_AUDIT_SORTING_ENTITY_FIELDS
        }
    }

}